module.exports = __webpack_public_path__ + "static/img/helh22.8febc8b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/healthycockpit/helh22.png
// module id = ZznY
// module chunks = 5